import { render } from "./spinerLoader.vue?vue&type=template&id=62c79c56"
import script from "./spinerLoader.vue?vue&type=script&lang=js"
export * from "./spinerLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__